import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Observer from '@researchgate/react-intersection-observer';
import Component from '../component';
import './index.css';

export default class CardContainer extends Component {
  static get propTypes() {
    return {
      onClick: PropTypes.func,
      img: PropTypes.string.isRequired,
      index: PropTypes.number
    };
  }

  constructor(props) {
    super(props);

    const image = this.image = new Image();
    image.src = props.img;
    image.addEventListener('load', this.imgLoaded, false);
    this.state = {
      loadImg: false,
      imgLoaded: false,
      transitioned: false
    };
  }

  getEventPointerPosition(e) {
    return {
      x: e.clientX,
      y: e.clientY + window.scrollY,
      scrollY: window.scrollY
    };
  }

  handleClick(e) {
    e.preventDefault();
    const position = this.getEventPointerPosition(e);
    this.props.onClick(position, this.props.index);
  }

  handleIntersection(e) {
    if (!e.isIntersecting) return;
    if (this.state.loadImg) return;
    this.setState({ loadImg: true });
  }

  handleTransition(e) {
    if (e.propertyName !== 'opacity') return;

    if (this.state.transitioned) return;
    this.setState({ transitioned: true });
    this.image.removeEventListener('load', this.imgLoaded);
  }

  componentWillUnmount() {
    this.image.removeEventListener('load', this.imgLoaded);
  }

  imgLoaded() {
    if (this.state.imgLoaded) return;
    this.setState({ imgLoaded: true });
  }

  render() {
    return (
      <article
        className={
          classNames('card-container', {
            loaded: this.state.imgLoaded,
            transitioned: this.state.transitioned
          })
        }
        style={
          this.state.loadImg
            ? { backgroundImage: `url(${ this.props.img })` }
            : null
        }
        onTransitionEnd={ this.handleTransition }
      >
        <MuiThemeProvider>
          <Observer
            onChange={ this.handleIntersection }
            onlyOnce={ true }
          >
            <a
              href={ `#${ this.props.id }` }
              onClick={ this.handleClick }>
              { this.props.children }
            </a>
          </Observer>
        </MuiThemeProvider>
      </article>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/card-container/index.jsx